import { memo } from 'react';
import { ListItemIcon, Menu, MenuItem } from '@mui/material';

import { MenuItemListType } from '../../type/MenuItemListType';

import theme from '../../../theme';

type PropsType = {
	anchorElOffsegMenu: HTMLElement | null;
	anchorElG500LiteMenu: HTMLElement | null;
	openOffsegMenu: boolean;
	openG500LiteMenu: boolean;
	handleCloseOffsegMenu: () => void;
	handleCloseG500LiteMenu: () => void;
	offsegMenuItemList: MenuItemListType;
	g500LiteMenuItemList: MenuItemListType;
};

/**
 * リダイレクトメニュー
 */
export const RedirectMenu = (props: PropsType) => {
	const {
		anchorElOffsegMenu,
		anchorElG500LiteMenu,
		openOffsegMenu,
		openG500LiteMenu,
		handleCloseOffsegMenu,
		handleCloseG500LiteMenu,
		offsegMenuItemList,
		g500LiteMenuItemList,
	} = props;
	return (
		<>
			<Menu
				sx={{ boxShadow: 0 }}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				anchorEl={anchorElOffsegMenu}
				open={openOffsegMenu}
				onClose={handleCloseOffsegMenu}
			>
				{offsegMenuItemList.map((menuItem, index) => (
					<MenuItem
						id={`offsegMenuItem${index}`}
						key={menuItem.value}
						value={menuItem.value}
						onClick={menuItem.onClick}
						sx={{ color: theme.palette.common.black }}
					>
						<ListItemIcon sx={{ color: theme.palette.common.black }}>
							<menuItem.icon />
						</ListItemIcon>
						{menuItem.name}
					</MenuItem>
				))}
			</Menu>
			<Menu
				sx={{ boxShadow: 0 }}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				anchorEl={anchorElG500LiteMenu}
				open={openG500LiteMenu}
				onClose={handleCloseG500LiteMenu}
			>
				{g500LiteMenuItemList.map((menuItem, index) => (
					<MenuItem
						id={`g500LiteMenuItem${index}`}
						key={menuItem.value}
						value={menuItem.value}
						onClick={menuItem.onClick}
						sx={{ color: theme.palette.common.black }}
					>
						<ListItemIcon sx={{ color: theme.palette.common.black }}>
							<menuItem.icon />
						</ListItemIcon>
						{menuItem.name}
					</MenuItem>
				))}
			</Menu>
		</>
	);
};

export default memo(RedirectMenu);
